import CMain from '../CMain';
import CPoint from '../cppComponents/CPoint';
import React from 'react';
import { View } from 'react-native';

class CBlackJack extends CMain {
    async LoadBitmaps() {}
    SetPlayerURating(username: string, rating: string) {
        console.log(username, rating);
    }
    SetAllMoneyForBet(username: string, arg1: number) {
        console.log(username, arg1);
    }
    async OnLButtonDown(point: CPoint) {
        console.log('point', point);
    }
    async OnRButtonDown(point: CPoint) {
        console.log('point', point);
    }
    async ReceiveGame(strRecvd: string) {
        console.log(strRecvd);
        return true;
    }
    Timer7() {}
    Timer3() {}
    Timer2() {}
    Timer4() {}
    constructor(props) {
        super(props);
    }
    Timer1() {}

    DrawView() {
        return null;
    }

    render() {
        if (this.props.m_pwin.game === 'BJ') {
            return <View key={'BJ'}>{this.DrawView()}</View>;
        } else {
            return null;
        }
    }
}

export default CBlackJack;
